import PlaceholderItem from './PlaceholderItem';
import Spinner from 'components/ui/Spinner';
import ResultItem, { ResultItemProps } from './ResultItem';
import { useHawkSearch } from 'components/StoreProvider';
import { ProductPriceResponse } from './data.HCL';
import React from 'react';

export interface ResultsListingProps {
	resultItem: React.ComponentType<ResultItemProps>;
	pricingAndAvailability?: ProductPriceResponse;
	isLoadingPricing: boolean;
}

function ResultListingHCL({ resultItem = ResultItem, pricingAndAvailability, isLoadingPricing }: ResultsListingProps) {
	const {
		store: { isLoading, searchResults },
	} = useHawkSearch();

	const results = searchResults ? searchResults.Results : [];
	const ResultComponent = resultItem;

	return (
		<div className="hawk-results__listing">
			<Spinner isVisible={isLoading} />
			{results.length && !isLoading
				? // if we have results, display them
				  results.map((result, index) => {
						const sku = result.getDocumentValue('product_sku');
						const productPricingAndAvailability = pricingAndAvailability?.productsPrices?.find(
							(r) => r.sku === sku,
						);

						return (
							<ResultComponent
								key={result.DocId}
								item={result}
								productPricingAndAvailability={productPricingAndAvailability}
								testId={index.toString()}
								isLoadingPricing={isLoadingPricing}
							/>
						);
				  })
				: // otherwise display placeholder items as we're loading
				  [...Array(12)].map((_, i) => <PlaceholderItem key={i} />)}
		</div>
	);
}

export default ResultListingHCL;
